


// 主页顶部显示的版本组件

import SHVersionIcon from './src/icon.vue';

/* istanbul ignore next */
SHVersionIcon.install = function(Vue) {
  Vue.component('sh-version-icon', SHVersionIcon);
};

export default SHVersionIcon;



// WEBPACK FOOTER //
// ./src/components/base/view/version/cmps/icon/index.js